var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-20" }, [
    _c("div", {}, [
      _vm.errMsg
        ? _c("div", { staticClass: "bg-FF p-40 text-center b-r-10" }, [
            _vm._v(_vm._s(_vm.errMsg)),
          ])
        : _c("div", [
            _c("div", { staticClass: "bg-FF p-40 b-r-10" }, [
              _c("div", { staticClass: "cor-33 font-38 font-weight-600" }, [
                _vm._v(" " + _vm._s(_vm.formData.title) + " "),
              ]),
              _c(
                "div",
                { staticClass: "cor-33 font-30 font-weight-400 m-t-20" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.formData.userName + " | " + _vm.formData.unitName
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "cor-66 font-30 font-weight-400 m-t-20" },
                [_vm._v(" " + _vm._s(_vm.formData.remark || "") + " ")]
              ),
            ]),
            _c(
              "div",
              { staticClass: "m-t-30 bg-FF p-40 b-r-10" },
              _vm._l(_vm.list, function (item, index) {
                return _c(
                  "van-row",
                  {
                    key: index,
                    staticClass: "p-t-20 p-b-20",
                    style: { borderTop: index != 0 ? "1px solid #eee" : "" },
                    attrs: {
                      justify: "space-between",
                      align: "center",
                      type: "flex",
                    },
                  },
                  [
                    _c(
                      "van-col",
                      { staticClass: "font-30 cor-33 font-weight-400" },
                      [_vm._v(" " + _vm._s(item.lable) + " ")]
                    ),
                    _c(
                      "van-col",
                      { staticClass: "font-30 cor-33 font-weight-600" },
                      [_vm._v(" " + _vm._s(item.value) + " ")]
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ]),
    ]),
    _vm.formData.confirm == "1"
      ? _c("div", { staticClass: "h-140" }, [
          _c(
            "div",
            { staticClass: "bottom-bar" },
            [
              _c(
                "van-button",
                {
                  staticClass: "m-t-30",
                  attrs: {
                    disabled: _vm.formData.isConfirmed == "1",
                    type: "primary",
                    round: "",
                    block: "",
                  },
                  on: { click: _vm.verify },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.formData.isConfirmed == "1"
                        ? "已 确 认"
                        : "确 认 无 误"
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }